import {RigFragment} from "Queries/Rig";
import gql from "graphql-tag";

export const RigQuery = gql`
    query getRig($id: ID!){
        getRig(_id: $id){
            ...RigFragment
        }
    }
    ${RigFragment}
`

export const RigsQuery = gql`
    query Quartermaster_GetPobRigs {
        GetPobRigs {
            ...RigFragment
        }
    }
    ${RigFragment}
`

export const SubRigChanges = gql`
    subscription RigUpdated {
        RigUpdated {
            rig {
                ...RigFragment
            }
            customerID
        }
    }
    ${RigFragment}
`